import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, Snackbar, DialogContent, DialogContentText, DialogActions, Dialog } from '@material-ui/core';
import { useMetaDataSettings } from './useMetaDataSettings';
import { DateTime, Products, Consent, Language } from './components';
import Alert from 'components/Alert';
import SaveMessage from 'views/UserMessaging/customModalContent/saveMessage';
import { Alert as AlertDialog, AlertTitle } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { unsetTimeZoneModified } from 'store/settings/actions';
import { useLanguageSettings } from './useLanguageSettings';
import { getEnvVar } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  footer: {
    padding: theme.spacing(4)
  }
}));

const Settings = () => {
  const classes = useStyles();
  const usingMetaDataSettings = useMetaDataSettings();
  const { languageContent, getLanguageContent } = useLanguageSettings();
  const [settingsContent, setSettingsContent] = useState(null);
  const {
    saveSettingsMetaData,
    isLoading,
    isSettingsMetaDataUpdating,
    isSettingsMetaDataUpdated,
    isSettingsMetaDataLoading,
    showFormSaveError
  } = usingMetaDataSettings;
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const isTimeZoneModified = useSelector(store => store.settings.isTimeZoneModified);
  const dispatch = useDispatch();

  useEffect(() => {
    if (languageContent) {
      setSettingsContent(getLanguageContent("settings"));
    }
  }, [languageContent]);

  useEffect(() => {
    dispatch(unsetTimeZoneModified());
  }, []);

  const onClickSave = () => {
    if (isTimeZoneModified) {
      setShowSaveConfirm(true);
    } else {
      saveSettingsMetaData();
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item md={7} xs={12}>
          <DateTime useMetaDataSettings={usingMetaDataSettings} dateTimeSettingsContent={settingsContent?.dateTime} />
          {getEnvVar('ADM_INCLUDE_LOCALIZATION') === 'true' && (
            <Language useMetaDataSettings={usingMetaDataSettings} languageSettingsContent={settingsContent?.language} />
          )}
          <Consent useMetaDataSettings={usingMetaDataSettings} consentSettingsContent={settingsContent?.consent} />
          <Products useMetaDataSettings={usingMetaDataSettings} productSettingsContent={settingsContent?.product} />
        </Grid>
        <Grid container spacing={4}>
          <Grid item md={7} xs={12}>
            <div className={classes.footer}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => onClickSave()}
                disabled={isLoading || isSettingsMetaDataUpdating}>
                {settingsContent?.buttonGroup?.saveButton || `Save Default Settings`}
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <SaveMessage
        openSnackbar={isSettingsMetaDataUpdated && !isSettingsMetaDataLoading}
      />
      <Snackbar open={showFormSaveError()} autoHideDuration={6000}>
        <Alert severity="error">
          {settingsContent?.alert?.error?.content || `Please correct issue(s) with the settings above`}
        </Alert>
      </Snackbar>

      {showSaveConfirm && isTimeZoneModified &&
        <Dialog open={true}>
          <AlertDialog severity="warning">
            <AlertTitle>{settingsContent?.alert?.warning?.title || `Save Confirmation`}</AlertTitle>
          </AlertDialog>
          <DialogContent>
            <DialogContentText>
              {settingsContent?.alert?.warning?.content || `Templates that use time zone have to be updated manually if 'Time Zone' is modified. Do you want to continue?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <DialogActions>
              <Button onClick={saveSettingsMetaData}>{settingsContent?.alert?.warning?.buttonGroup?.save ||`Save`}</Button>
              <Button onClick={() => setShowSaveConfirm(false)}>{settingsContent?.alert?.warning?.buttonGroup?.cancel || `Cancel`}</Button>
            </DialogActions>
          </DialogActions>
        </Dialog>}
    </div>
  );
};

export default Settings;
